import { BrowserFileReader } from '@/platform'

function readVariableStringLength(reader: CSBinReader): number {
  let length = reader.readIntOne()
  if (length >= 128) {
    const next = reader.readIntOne()
    length = (next - 1) * 128 + length
  }
  return length
}

export default class CSBinReader extends BrowserFileReader {
  public strDict: Map<number, string> = new Map()

  public readIntOne(): number {
    const bytes = this.readSome(1)
    return bytes.length > 0 ? bytes[0]! : 0
  }

  public readNext(): number {
    return this.readIntOne()
  }

  public readInt16LEValue(): number {
    const bytes = this.readSome(2)
    if (bytes.length < 2) {
      return 0
    }
    return new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength).getInt16(0, true)
  }

  public readCSBinString(): string {
    const length = readVariableStringLength(this)
    if (length <= 0) {
      return ''
    }
    return new TextDecoder().decode(this.readSome(length))
  }

  public readCSBinValueString(): string {
    const marker = this.readIntOne()
    if (marker === 0x0a) {
      return 'null'
    }

    let strId = -1
    if (marker === 0x06) {
      strId = this.readInt()
      const length = readVariableStringLength(this)
      const value = length > 0 ? new TextDecoder().decode(this.readSome(length)) : ''
      this.strDict.set(strId, value)
      return value
    }

    if (marker === 0x09) {
      strId = this.readInt()
      return this.strDict.get(strId) ?? 'null'
    }

    return 'null'
  }
}
